import {request} from "../../request/request";
import {OAUTH_CLIENT_ID, OAUTH_CLIENT_SECRET} from "../../data/constants";

const refreshToken = {
  createToken: (data) => {
    const oauthCredentials = {
      grant_type: 'refresh_token',
      client_id: OAUTH_CLIENT_ID,
      client_secret: OAUTH_CLIENT_SECRET,
      scope: '',
    };

    return request.create('/oauth/refresh-token/refresh', Object.assign({}, oauthCredentials, data));
  },
};

export {refreshToken};